import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class ImpactedHostsChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "",
          data: [0.39, 0.16, 0, 0, 0, 0, 0],
        },
      ],
      options: {
        chart: {
          type: "area",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "Not Mapped",
            "Not Tagged",
            "Network-Network/Network",
            "Network-Network/Network",
            "Network-Network/Network",
            "Network-Network/Network",
            "Nokia NFMP",
          ],
          title: {
            text: "Hosts", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        yaxis: {
          labels: {
            // formatter: function (val) {
            //   return parseInt(val);
            // },
          },
          title: {
            text: "Alarms (in M)", // Title for the Y-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          stepSize: 0.1,
          decimalsInFloat: true,
        },
        stroke: {
          curve: "straight",
          width: 3,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            columnWidth: "90%",
            distributed: true,
            borderRadius: 5,
          },
        },
      },
    };
  }

  render() {
    return (
      <>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={300}
        />
      </>
    );
  }
}
